'use client'

import { useLingui } from '@lingui/react/macro'
import { motion } from 'motion/react'
import { LocalizedLink as Link } from '~/components/localized-link'

export const SpaceDetailsNav = ({ spaceTitle }: { spaceTitle: string }) => {
	const { t } = useLingui()

	return (
		<motion.div
			initial={{ opacity: 0, translateY: -100 }}
			animate={{ opacity: 1, translateY: 0 }}
			exit={{ opacity: 0, translateY: -100 }}
			className='fixed top-[60px] right-0 left-auto z-20 hidden w-full bg-white shadow md:block'
		>
			<div className='container flex flex-row items-center justify-between gap-8 md:pl-[84px]'>
				<strong className='mr-auto'>{spaceTitle}</strong>

				<div className='flex flex-row gap-12'>
					<Link
						className='hover:text-primary py-2'
						href={{ hash: 'photos' }}
					>
						{t`Photos`}
					</Link>

					<Link
						className='hover:text-primary py-2'
						href={{ hash: 'services' }}
					>
						{t`Prestations et équipements`}
					</Link>

					<Link
						className='hover:text-primary py-2'
						href={{ hash: 'prices' }}
					>
						{t`Offres & Devis`}
					</Link>

					<Link
						className='hover:text-primary py-2'
						href={{ hash: 'location' }}
					>
						{t`Localisation`}
					</Link>
				</div>
			</div>
		</motion.div>
	)
}
